import { removeNullUndefinedEmpty } from '@thecompaniesapi/object-helpers'

export default function useCompany() {
  const companyDomain = useRouteQuery<string>('domain', '')
  const companyDomainsQuery = useRouteQuery('domains-group', '')
  const history = useManualRefHistory(companyDomain)
  const guards = useGuards()
  const router = useRouter()
  const route = useRoute()

  const companyDomains = computed(() => {
    return companyDomainsQuery.value?.split(',') || []
  })

  const showCompanyProfile = (domain?: string) => {
    if (guards.userOnly() && domain) {
      router.replace({
        name: String(route.name),
        params: { ...route.params },
        query: removeNullUndefinedEmpty({
          ...route.query,
          domain,
          ...(companyDomains.value.length ? { 'domains-group': companyDomains.value.join(',') } : {}),
        }),
      })
    }
  }

  const showCompanyGroup = (domains: string[], domain?: string) => {
    if (guards.userOnly() && domains.length) {
      router.replace({
        name: String(route.name),
        params: { ...route.params },
        query: removeNullUndefinedEmpty({
          ...route.query,
          'domain': domain || domains[0],
          'domains-group': domains.join(','),
        }),
      })
    }
  }

  const nextGroupCompany = computed(() => {
    if (!companyDomains.value.length) {
      return
    }

    const currentIndex = companyDomains.value.indexOf(companyDomain.value)
    const nextIndex = (currentIndex + 1) % companyDomains.value.length

    return companyDomains.value[nextIndex]
  })

  const previousGroupCompany = computed(() => {
    if (!companyDomains.value.length) {
      return
    }

    const currentIndex = companyDomains.value.indexOf(companyDomain.value)
    const previousIndex = (currentIndex - 1 + companyDomains.value.length) % companyDomains.value.length

    return companyDomains.value[previousIndex]
  })

  return {
    companyDomain,
    companyDomains,
    companyDomainsQuery,
    history,
    nextGroupCompany,
    previousGroupCompany,
    showCompanyGroup,
    showCompanyProfile,
  }
}
